import dayjs, { Dayjs } from "dayjs";
import { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { useGlobal } from "../../components/GlobalProviderLayout";
import { DateRange, RESET_DATE_RANGE, SET_DATE_RANGE } from "../../components/GlobalProviderLayout/GlobalProviderLayoutModel";
import { DispatchHistory } from "./DispatchHistory";

export const DispatchHistoryRoute = () => {
  const currentDate = dayjs();
  const weekAgoDate = dayjs().subtract(1, 'week');
  const navigate = useNavigate();
  const { state, dispatch } = useGlobal();
  const [dateError, setDateError] = useState<(string | null)[]>(['', '']);
  const [startDate, endDate] = state.dateRange;
  const disabledView = !startDate || !endDate || !!dateError[0] || !!dateError[1];
  const formattedDate = (date: Dayjs | null) => dayjs(date).format('DD.MM.YYYY');
  const handleView = () => navigate(`/dispatch-history-results/${formattedDate(startDate)}/${formattedDate(endDate)}`);


  useEffect(() => {
    if (!state.previousLocation?.includes('/dispatch-history')) {
      dispatch({ type: RESET_DATE_RANGE })
    }
  }, [dispatch, state.previousLocation])

  useEffect(() => {
    if (!startDate && !endDate) {
      dispatch({ type: SET_DATE_RANGE, payload: [weekAgoDate, currentDate] });
    }
  }, [currentDate, weekAgoDate, dispatch, startDate, endDate])

  const handleDateChange = (date: Dayjs | null, isStart = true) => {
    const start = isStart ? date : state.dateRange[0];
    const end = isStart ? state.dateRange[1] : date;
    const payload: DateRange = [start, end];
    dispatch({ type: SET_DATE_RANGE, payload })
    setDateError([null, null]);
  }

  const dateRangePickerComponentProps = {
    onError: setDateError,
    startDate,
    endDate,
    handleDateChange,
    error: dateError
  };

  return (
    <DispatchHistory
      dateRangePickerComponentProps={dateRangePickerComponentProps}
      handleView={handleView}
      disabledView={disabledView}
    />
  )
}